<!-- 全局查询 -->
<template>
    <div class="more-details">
        <el-scrollbar style="height: 100%;width: 100%;">
            <div class="more-details-content">
                <div class="header">
                    <span class="go-back" @click="goBack()">
                        <i class="iconfont icon-fanhui"></i>
                        <span>返回</span>
                    </span>
                        <span class="crumbs">
                        云上看地 > 详情页
                    </span>
                </div>
                <div class="information">
                    <el-row>
                        <el-col :span="9">
                            <div class="information-img">
                                <div v-show="qjtShow" style="width: 100%;height: 100%;">
                                    <!--  <photosphereviewer :showphotespheremarker="true" :tableImgHeight="'400px'" :landinfo ="landinfo" ></photosphereviewer> -->
                                     <mobilephotosphereviewer :showphotespheremarker="true" :tableImgHeight="'390px'" :landinfo ="landinfo" ></mobilephotosphereviewer>

                                </div>
                                <div v-show="!qjtShow" class="no-data">
                                    <i class="iconfont icon-zanwutupian"></i>
                                </div>
                                <div class="time">
                                    <span>示意图拍摄时间：{{landinfo.qjtpsDate}}</span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="15">
                            <div class="information-content">
                                <div class="title">{{landinfo.dkmc}}</div>
                                <div class="type clearfix">
                                    <div class="left">
                                        <span>用地类型</span>
                                        <span>{{landinfo.ydxzmc}}</span>
                                    </div>
                                    <div class="right">
                                        <span>浏览</span>
                                        <span><span class="num">{{landinfo.visitcount}}</span>次</span>
                                    </div>
                                </div>
                                <div class="location-area" :style="'background-image:url('+ areaBG +')'">
                                    <div>
                                        <i class="iconfont icon-dingwei"></i>
                                        <span>{{landinfo.dkdz}}</span>
                                    </div>
                                    <div>
                                        <i class="iconfont icon-mianji"></i>
                                        <span>面积<span class="num">{{dkmj}}</span>亩</span>
                                    </div>
                                </div>
                                <div class="other">
                                    <el-row>
                                        <el-col :span="12">
                                            <span>行政区</span>
                                            <span>{{landinfo.xzqmc}}</span>
                                        </el-col>
                                        <el-col :span="12">
                                            <span>土地用途</span>
                                            <span>{{landinfo.tdyt}}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="12">
                                            <span>容积率</span>
                                            <span>{{landinfo.rjl}}</span>
                                        </el-col>
                                        <el-col :span="12">
                                            <span>开发程度</span>
                                            <span>{{landinfo.kfcd}}</span>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="code clearfix">
                                    <div style="width: 110px;float: left;">
                                        <div class="name">专属土地码</div>
                                        <div class="code-img" id="qrcodeDiv" @click="ewmClickHnalder">
                                           <img :src="ewmUlr" alt=""/>
                                        </div>
                                    </div>
                                    <div :style="'background-image:url('+ recommendationBG +')'" class="recommendation left clearfix">
                                        <div class="name left">
                                            推介说明
                                        </div>
                                        <div class="recommendation-content right">
                                            <el-scrollbar style="height: 100%;">
                                                <div>
                                                    <span>{{landinfo.tjsm}}</span>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="complete-conditions">
                    <el-tabs v-model="moreDetailsTabsValue">
                        <el-tab-pane label="周边配套" name="ZBPT">
                            <div class="complete">
                                <div class="header">
                                    周边配套
                                </div>
                                <div class="complete-content">
                                    <ul>
                                        <li v-for="(item, index) in list" :key="'list'+index">
                                            <div class="name">
                                                <span :style="'background:'+ item.color" class="icon">
                                                    <i :class="'iconfont '+ item.icon "></i>
                                                </span>
                                                <span v-html="item.type"></span>
                                            </div>
                                            <div class="distance">
                                                <span v-show="item.children.length===0">暂无</span>
                                                <div v-show="childrenIndex<12 && !item.flag" v-for="(childrenItem, childrenIndex) in item.children" :key="'childrenItem1'+ index+childrenIndex">
                                                    <span>距{{childrenItem.itmename}}：{{childrenItem.distance}}米</span>
                                                </div>
                                                <div v-show="item.flag" v-for="(childrenItem, childrenIndex) in item.children" :key="'childrenItem2'+ index+childrenIndex">
                                                    距{{childrenItem.itmename}}：{{childrenItem.distance}}米
                                                </div>
                                            </div>
                                            <div v-show="item.children.length > 12" class="more-button">
                                                <div><span v-show="!item.flag" @click="distanceExpand(index)">更多 <i class="iconfont icon-xiala"></i></span></div>
                                                <div><span v-show="item.flag" @click="distancePack(index)">收起 <i class="iconfont icon-shouqi2"></i></span></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="规划条件" name="GHTJ">
                            <div class="conditions">
                                <div class="header">
                                    规划条件
                                </div>
                                <div class="more-details-table">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td>出让面积(亩)</td>
                                            <td>{{dkmj}}</td>
                                            <td>使用年限(年)</td>
                                            <td>{{landinfo.crnx}}</td>
                                        </tr>
                                        <tr>
                                            <td>容积率</td>
                                            <td>{{landinfo.rjl}}</td>
                                            <td>建筑密度(%)</td>
                                            <td>{{landinfo.jzmd}}</td>
                                        </tr>
                                        <tr>
                                            <td>绿地率(%)</td>
                                            <td>{{landinfo.lhl}}</td>
                                            <td>建筑限高(米)</td>
                                            <td>{{landinfo.jzxg}}</td>
                                        </tr>
                                        <tr>
                                            <td>其他条件</td>
                                            <td colspan="3">{{landinfo.qt}}</td>
                                        </tr>
                                         <tr>
                                            <td style="width: 20%;">社区配套</td>
                                            <td colspan="3">{{landinfo.sqpt}}</td>
                                        </tr>
                                        <tr>
                                            <td>养老配套</td>
                                            <td colspan="3">{{landinfo.ylpt}}</td>
                                        </tr>
                                        <tr>
                                            <td>教育配套</td>
                                            <td colspan="3">{{landinfo.jypt}}</td>
                                        </tr>
                                        <tr>
                                            <td>其他配套</td>
                                            <td colspan="3">{{landinfo.qtpt}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="conditions-content">
                              <div v-for="(Item, index) in ghfjArray" :key="'childrenItem'+ index">
                                     <img :src="Item.url" alt=""/>
                                </div>
                                </div>
                            </div>
                        </el-tab-pane>
                       <!--  <el-tab-pane label="规划配套" name="GHPT">
                            <div class="planning">
                                <div class="header">
                                    规划配套
                                </div>
                                <div class="more-details-table">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td style="width: 20%;">社区配套</td>
                                            <td colspan="3">{{landinfo.sqpt}}</td>
                                        </tr>
                                        <tr>
                                            <td>养老配套</td>
                                            <td colspan="3">{{landinfo.ylpt}}</td>
                                        </tr>
                                        <tr>
                                            <td>教育配套</td>
                                            <td colspan="3">{{landinfo.jypt}}</td>
                                        </tr>
                                        <tr>
                                            <td>其他配套</td>
                                            <td colspan="3">{{landinfo.qtpt}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </el-tab-pane> -->
                        <el-tab-pane label="出让信息" name="CRXX">
                            <div class="transfer">
                                <div class="header">
                                    出让信息
                                </div>
                                <div class="more-details-table">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td style="width: 20%;">网挂地块编号</td>
                                            <td style="width: 30%;">{{landinfo.dkbh}}</td>
                                            <td style="width: 20%;">竞得人</td>
                                            <td style="width: 30%;">{{landinfo.jdr}}</td>
                                        </tr>
                                        <tr>
                                            <td>成交价(万元)</td>
                                            <td>{{landinfo.cjj}}</td>
                                            <td>竞得日期</td>
                                            <td>{{landinfo.jdDate}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="explain">最终数据以相关部门出具的正式数据为准</div>
                </div>
            </div>
        </el-scrollbar>
        <div class="map-expand" v-show="mapExpand">
            <div class="expand-cotent">
                <div class="narrow" @click="narrowClick">
                    <i class="iconfont icon-suoxiao"></i>
                </div>
                <div class="title">
                    <span v-html="landinfo.dkmc"></span>
                </div>
                <img :src="ewmUlr" alt=""/>
            </div>
        </div>
    </div>
</template>

<script>

import {mapResourceApi} from '@/api/mapResourceApi'
import QRCode from 'qrcode'
import { Notification } from 'element-ui'
import areaBG from '@/assets/images/mapView/location.png'
import recommendationBG from '@/assets/images/mapView/recommendation.png'
import {mapmanager, xzqUtils} from '@/views/class/mapmanager'
import photosphereviewer from 'components/main-map/photosphereviewer'
import mobilephotosphereviewer from 'components/main-map/mobilephotosphereviewer.vue'
export default {
  components: {
    photosphereviewer,
    mobilephotosphereviewer
  },
  data() {
    return {
      showphotoSphereViewer: false,
      dkmj: 0,
      drawData: [],
      sphereCorrection: { pan: 0, tilt: 0, roll: 98 },
      resultlistShow: false,
      mapExpand: false,
      areaBG,
      recommendationBG,
      panorama: require('@/assets/images/mapView/mapview.jpg'),
      imgurl1: require('@/assets/images/mapView/mapview.jpg'),
      landinfo: {},
      list: [],
      moreDetailsTabsValue: 'ZBPT',
      ghfjArray: [],
      ewmUlr: '',
      qjtShow: false
    }
  },
  watch: {
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    //
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    const _this = this
    const params = {
      id: this.$route.params.id
    }
    _this.ghfjArray = []
    mapResourceApi.getLandInfoAndMatchingById(params).then(response => {
      if (response.code === '200' && response.data) {
        this.landinfo = response.data.landinfo
        if (!this.landinfo.visitcount) {
          this.landinfo.visitcount = 0
        }
        this.landinfo.ydxzmc = mapmanager.getYdxzName(this.landinfo.ydxz)
        this.landinfo.xzqmc = xzqUtils.getXZQNAME(this.landinfo.xzq)
        const mj = this.landinfo.dkmj
        this.dkmj = mj.toFixed(2)

        this.photespheremarkerlist = response.data.photespheremarkerlist
        for (let i = 0; i < response.data.list.length; i++) {
          response.data.list[i].flag = false
        }
        this.list = response.data.list
        this.showphotoSphereViewer = true
        if (this.landinfo.ghfj) {
          const fjArray = this.landinfo.ghfj.split('&')
          for (let index = 0; index < fjArray.length; index++) {
            const element = fjArray[index]
            const oject = {}
            oject.url = `${gisserverUrl}` + element
            _this.ghfjArray.push(oject)
          }
        }
        this.initViewer(this.landinfo.qjt)
        this.getEwm()
        this.updateVisitcount(this.landinfo.visitcount)
      } else {
        Notification.warning({
          title: '警告',
          message: '加载更多详情数据出错...',
          type: 'warning'
        })
      }
    })
  },
  methods: {

    ewmClickHnalder() {
      this.mapExpand = true
    },
    getEwm() {
      const _this = this
      const localhostPaht = window.document.location.origin
      const url = localhostPaht + '/mobileMoreDetails/' + this.landinfo.id
      QRCode.toDataURL(url)
        .then(url => {
          _this.ewmUlr = url
        })
        .catch(err => {
          console.error(err)
        })
    },
    initViewer(qjt) {
      if (qjt) {
        this.qjtShow = true
      } else {
        this.qjtShow = false
      }
    },
    // 返回
    goBack() {
      this.$router.push({
        name: 'index'
      })
    },
    expand() {
      this.mapExpand = true
    },
    narrowClick() {
      this.mapExpand = false
    },
    distanceExpand(index) {
      this.list[index].flag = true
    },
    distancePack(index) {
      this.list[index].flag = false
    },
    updateVisitcount(visitcount) {
      this.landinfo.visitcount = visitcount + 1
      const params = {
        id: this.$route.params.id,
        visitcount: this.landinfo.visitcount
      }
      mapResourceApi.updateLandInfoVisitcount(params).then(response => {
        if (response.code === '200' && response.data) {
        } else {
          Notification.warning({
            title: '警告',
            message: '加载浏览次数数据出错...',
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .more-details{
        width: 100%;
        height: 100%;
        background: #f7f8fa;
        text-align: left;
        position: relative;
        .more-details-content{
            width: 1200px;
            margin: 0 auto;
            padding: 10px 0px;
            .header{
                font-size: 14px;
                .go-back{
                    height: 24px;
                    background: #4293f4;
                    border-radius: 4px;
                    color: #ffffff;
                    cursor: pointer;
                    line-height: 24px;
                    padding: 0px 8px;
                    display: inline-block;
                    margin-right: 10px;
                    i.iconfont{
                        font-size: 14px;
                    }
                }
            }
            .information{
                background: #ffffff;
                box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.16);
                margin: 10px 0px 20px;
                padding: 20px;
                .information-img{
                    height: 387px;
                    position: relative;
                    .time{
                        position: absolute;
                        left: 10px;
                        top: 10px;
                        z-index: 10;
                        background: rgba(0,0,0,0.5);
                        padding:6px 10px;
                        color: #fff;
                        font-size: 14px;
                        border-radius: 4px;
                    }
                    .img-button{
                        width: 28px;
                        height: 28px;
                        background: rgba(0,0,0,0.5);
                        border-radius: 50%;
                        position: absolute;
                        top: 12px;
                        right: 12px;
                        text-align: center;
                        line-height: 28px;
                        cursor: pointer;
                        z-index: 9999;
                        i.iconfont{
                            font-size: 14px;
                            color: #fff;
                        }
                    }
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .no-data{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #F2F5F6;
                        border-radius: 4px;
                        i.iconfont{
                            color: #D0DCE5;
                            font-size: 56px;
                            text-align: center;
                        }
                    }
                }
                .information-content{
                    height: 387px;
                    padding-left: 20px;
                    .title{
                        font-size: 24px;
                        font-weight: bold;
                        color: #333333;
                    }
                    .type{
                        margin: 15px 0px;
                        >div{
                            >span{
                                font-size: 14px;
                                &:first-child{
                                    color: #999999;
                                    margin-right: 6px;
                                }
                                &:last-child{
                                    color: #333;
                                }
                                .num{
                                    color: #CC0101;
                                }
                            }
                        }
                    }
                    .location-area{
                        height: 76px;
                        width: 100%;
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    /*     border: 1px dashed #333; */
                        padding: 10px;
                        margin-bottom: 20px;
                        >div{
                            color: #333333;
                            font-size: 14px;
                            line-height: 28px;
                            i.iconfont{
                                font-size: 14px;
                                margin-right: 6px;
                            }
                            .num{
                                color: #CC0101;
                                margin: 0px 5px;
                            }
                        }
                    }
                    .other{
                        border-bottom: 1px dashed #dedede;
                        margin-bottom: 15px;
                        span {
                            font-size: 14px;
                            display: inline-block;
                            margin-bottom: 15px;
                            &:first-child {
                                color: #999999;
                                margin-right: 6px;
                            }
                            &:last-child {
                                color: #333;
                            }
                        }
                    }
                    .code{
                        .name{
                            font-size: 14px;
                            color: #999999;
                            margin-bottom: 10px;
                        }
                        .code-img{
                            width: 108px;
                            height: 108px;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .recommendation{
                            width: calc(100% - 110px);
                            height: 100%;
                            background: #f8fafe;
                            border: 1px solid rgba(47,128,237,0.40);
                            height: 127px;
                            padding: 10px 10px 10px 0px;
                            background-repeat: no-repeat;
                            background-position: 3% bottom;
                            .name{
                                width: 120px;
                                height: 100%;
                                font-size: 14px;
                                color: #2f80ed;
                                text-align: center;
                            }
                            .recommendation-content{
                                width: calc(100% - 130px);
                                font-size: 14px;
                                color: #545864;
                                height: 100%;
                            }
                        }
                    }
                }
            }
            .complete-conditions{
                background: #ffffff;
                padding: 20px;
                .header{
                    height: 24px;
                    padding-left: 15px;
                    border-left: 5px solid #2F80ED;
                    font-size: 18px;
                    font-weight: 700;
                    color: #333333;
                    margin-bottom: 10px;
                }
                .complete{
                    margin-bottom: 20px;
                    .complete-content{
                        padding: 20px;
                        background: #f7f8fa;
                        li{
                            margin-bottom: 10px;
                            .name{
                                font-size: 14px;
                                font-weight: 700;
                                color: #333333;
                                line-height: 20px;
                                .icon{
                                    width: 20px;
                                    height: 20px;
                                    border-radius: 50%;
                                    text-align: center;
                                    line-height: 20px;
                                    display: inline-block;
                                    margin-right: 10px;
                                    vertical-align: middle;
                                    i.iconfont{
                                        font-size: 12px;
                                        color: #fff;
                                    }
                                }
                                span{
                                    &:last-child{
                                        vertical-align: middle;
                                    }
                                }
                            }
                            .distance{
                                display: flex;
                                width: 100%;
                                flex-wrap: wrap;
                                margin-top: 10px;
                                >div{
                                    width: 25%;
                                    margin-bottom: 10px;
                                    font-size: 14px;
                                    color: #333333;
                                }
                            }
                            .more-button{
                                font-size: 14px;
                                color: #2f80ed;
                                text-align: center;
                                span{
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
                .conditions{
                    .conditions-content{
                        padding: 20px;
                        background: #f7f8fa;
                        margin-top: 10px;
                    }
                }
                .planning{
                }
                .transfer{
                }
            }
        }
        .more-details-table{
            table{
                width: 100%;
                border-collapse:collapse;
                border-spacing:0;
                td{
                    padding: 10px;
                    font-size: 14px;
                    color: #333333;
                    border: 1px solid #dddddd;
                    &:nth-child(odd){
                        background: #f5f6f8;
                        text-align: right;
                    }
                }
            }
        }
        .explain{
            text-align: center;
            font-size: 14px;
            color: #CC0101;
        }
        .map-expand{
            position: fixed;
            width: 100%;
            background: rgba(0,0,0,0.5);
            border-radius: 4px;
            overflow: hidden;
            top: 0px;
            height: 100%;
            z-index: 9999;
            .expand-cotent{
                margin: 100px 200px;
                height: calc(100% - 200px);
                width: calc(100% - 400px);
                position: relative;
                text-align: center;
                .title{
                    font-size: 16px;
                    color: #333;
                    position: absolute;
                    z-index: 1000;
                    left: 50%;
                    transform: translateX(-50%);
                    top: 10px;
                }
                .narrow{
                    width: 28px;
                    height: 28px;
                    background: rgba(0,0,0,0.5);
                    border-radius: 50%;
                    position: absolute;
                    top: 12px;
                    right: 27%;
                    text-align: center;
                    line-height: 28px;
                    cursor: pointer;
                    i.iconfont{
                        font-size: 14px;
                        color: #fff;
                    }
                }
                img{
                    /* width: 100%; */
                    height: 100%;
                }
            }
        }
        ::v-deep{
            .el-scrollbar__wrap{
                overflow-x: hidden;
            }
        }
    }
    @media (max-width: 1366px) {
        .more-details{
            .map-expand{
                .expand-cotent{
                    .narrow{
                        right: 29%;
                    }
                }
            }
        }
    }
</style>
